exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".recaptcha-container[data-v-2415a6d3] {\n  display: inline-block;\n  width: auto;\n}", ""]);

// exports
